import React, { useEffect, useRef, useState} from 'react';
import { caregap_name, exchangeDate, notify } from "../../helpers";
import { getCareGapHistory } from '../../services/caregaps';
import { SquareCheckBig, SquareX } from 'lucide-react';
import Spacing from '../Spacing';
import { Drawer } from 'vaul';

const listItemStyle = {
  position: 'relative',
  marginBottom: '10px',
};

const listItemBeforeStyle = {
  content: "''",
  position: 'absolute',
  left: '-25px',
  top: '0',
  width: '20px',
  height: '20px',
  backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="%23373737e3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-hand-heart"><path d="M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16"/><path d="m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"/><path d="m2 15 6 6"/><path d="M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z"/></svg>')`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
};

export default function PatientCareGapViewModal({ ...props }) {
  const [historyData, setHistoryData] = useState([]);
  const dropdownRef = useRef(null);

  const {    
    account_id,
    location_id,
    patient_id = "",
    age = "",
    gender = "",
    last_visit = "",
    activeModal,
    setActiveModal = () => {},
    setOpacityClass = () => {},
    previousScrollPosition = 0
  } = props;

  const loadData = async (account_id, location_id, patient_id, age, gender) => {
    const response = await getCareGapHistory( account_id, location_id, patient_id, age, gender );
    if (response) {
      if( Object.keys(response?.data)?.length === 0) {
        notify("success", "No Care Gap History found for this patient");
        handleDrawerClose();
      } else {
        setHistoryData(response?.data);
      }
    } else {
      notify("error", "Something went wrong");
      handleDrawerClose();
      setOpacityClass("docpro_opaciry_1")
    }
  };
  const modalStatus = (status) => {   
    setActiveModal(status)
    if (status) { 
      loadData(account_id, location_id, patient_id, age, gender);
    }   
  };

  useEffect(() => {
    modalStatus(activeModal)
  }, []);

  const sortedHistoryData = Object.entries(historyData).sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA));

  const handleDrawerClose = () => {
    setActiveModal(false);
    setOpacityClass("docpro_opaciry_1")
    // window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Patient Care Gap History</Drawer.Title>
            <Drawer.Description className="sr-only">View details of a parient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg" style={{ overflow: 'unset' }}>
              <div className="docpro_modal small">

                {sortedHistoryData.length === 0 ? (
                  <div
                    style={{
                      height: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Loading...
                  </div>
                ) : (
                  <div className='docpro_bg_white'>
                    <h3 className="docpro_fs_18 docpro_mb_0">Care Gaps History</h3>
                    <Spacing lg="20" sm="20" />

                    <ul className='care_list_style docpro_mb_0'>
                      {sortedHistoryData.map(([date, gaps], index) => (
                        <li key={index} style={listItemStyle}>
                          <span style={listItemBeforeStyle}></span>
                          <strong style={{ paddingLeft: '6px', color: '#373737e3' }}>
                            {last_visit !== null ? 
                              (date <= last_visit) ? exchangeDate(date) : exchangeDate(date)+ ' (current Date)'
                            : 
                              exchangeDate(date)
                            }:
                          </strong>
                          <div className='all_lists'>
                            {gaps.map((gap, gapIndex) => (
                              <div key={gapIndex} style={{ marginTop: '5px', display: 'flex', alignItems: 'center' }}>
                                {gap?.status === 'pending' ? 
                                  <>
                                    <span className='docpro_tip_checkbox'>
                                      <SquareX color="orange" width={18} height={18} style={{ marginRight: '8px' }} />
                                      <span className="docpro_tip">Pending Care Gap</span>
                                    </span>
                                  </>
                                : 
                                  <>
                                    <span className='docpro_tip_checkbox'>
                                      <SquareCheckBig color="green" width={18} height={18} style={{ marginRight: '8px' }} />
                                      <span className="docpro_tip">Completed Care Gap</span>
                                    </span>
                                  </>
                                }

                                {caregap_name(gap?.care_gap_id)} 
                                {(date !== gap?.dos && gap?.status !== 'pending') && (
                                  <>
                                    <span style={{ padding: '0 4px' }}> - </span> 
                                    <span className='docpro_tip_checkbox' style={{ color: '#929292' }}>
                                      {exchangeDate(gap?.dos)}
                                      <span className="docpro_tip">Previous Completed Date</span>
                                    </span>
                                  </>
                                )}
                              </div>
                            ))}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}